// 手动埋点
export function postTrack(name='',type='click') {
  window.YlTrack.report({
    trackName: name,
    trackNameZh:name,
    trackType: type,
  });
}
export const ceshidata = {}
